export default {
  addOns: 'Adicionais',
  all: 'Todos',
  browse: 'Explorar',
  buyTickets: 'Comprar ingressos',
  countSelected: '{{count}} selecionados',
  joinWaitlist: 'Entrar na lista de espera',
  joining: 'Entrando',
  noDatesAvailable: 'Nenhuma data disponível',
  salesEnded: 'Vendas encerradas',
  schedule: 'Cronograma',
  seeMoreDates: 'Ver mais datas',
  soldOut: 'Esgotado',
  about: 'Sobre',
  agenda: 'Agenda',
  menu: 'Menu',
  included: 'Incluído',
  viewMore: 'Ver mais',
  viewLess: 'Ver menos',
  location: 'Localização',
  time: 'Hora',
  at: 'em',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Não há horários disponíveis nesta data para este tamanho de grupo',
  availableTimes: 'Horários disponíveis',
  waitlist: 'Lista de espera',
  continue: 'Continuar',
  tickets: 'Ingressos',
  ticketsAreNoLongerAvailable: 'Ingressos não estão mais disponíveis.',
  checkOutOutOtherExperiences: 'Confira nossas outras experiências!',
  viewExperiences: 'Ver experiências',
  from: 'de',
  rsvp: 'RSVP',
  nights: 'noites',
  request: 'Solicitar',
  arrival: 'Chegada',
  departure: 'Partida',
};
